import { Container, Title, Text, Box, List } from '@mantine/core';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

export default function TermsAndConditions() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <TermsAndConditionsContent />
    );
}

export const TermsAndConditionsContent = () => {

    return <Container size="lg" py="xl">
        <Helmet>
            <title>{`Terms And Conditions - Thrift Store Nepal`}</title>
            <meta
                name="description"
                content="Products - Thrift Store Nepal - Search for your best matching thrift item according to different category and criteria. Buy and sell preowned clothes and other accessories on Nepal's first digital thrift shop - Thrift Store Nepal (Thrift Shop Nepal)"
            />
            <meta property="og:title" content="Products - Thrift Store Nepal" />
            <meta
                property="og:description"
                content="Products - Thrift Store Nepal - Buy and sell preowned clothes and other accessories on Nepal's first digital thrift shop - THrift Store Nepal (Thrift Shop Nepal)"
            />
            <meta name="og:image" content="/assets/images/og-2.png" />
        </Helmet>
        <Title order={1} align="center" mb="xl">
            Terms And Conditions
        </Title>

        <Box mb="xl">
            <Text>
                Welcome to Thrift Store Nepal! By accessing or using our website, you agree to comply with and be bound by the following terms and conditions.
                Please read these terms carefully. If you do not agree with any part of these terms, you may not use our website or services.
            </Text>
        </Box>

        <Box mb="xl">
            <Title order={2} mb="md">
                1. General Information
            </Title>
            <List>
                <List.Item>Thrift Store Nepal is an online platform where users can buy and sell pre-owned clothes.</List.Item>
                <List.Item>We do not own or sell any products directly. We only facilitate the connection between sellers and buyers.</List.Item>
                <List.Item>We do not charge any commissions on sales.</List.Item>
            </List>
        </Box>

        <Box mb="xl">
            <Title order={2} mb="md">
                2. Eligibility
            </Title>
            <List>
                <List.Item>You must be at least 18 years old to register and use our platform. If you are under 18, you may use the platform only with the involvement of a parent or legal guardian.</List.Item>
                <List.Item>By signing up, you confirm that the information provided is accurate and up-to-date.</List.Item>
            </List>
        </Box>

        <Box mb="xl">
            <Title order={2} mb="md">
                3. Account Registration
            </Title>
            <List>
                <List.Item>Users are required to create an account to list or purchase products.</List.Item>
                <List.Item>You are responsible for maintaining the confidentiality of your login credentials and any activity that occurs under your account.</List.Item>
                <List.Item>Thrift Store Nepal reserves the right to suspend or terminate accounts at our discretion if any fraudulent or harmful activity is detected.</List.Item>
            </List>
        </Box>

        <Box mb="xl">
            <Title order={2} mb="md">
                4. Listing and Selling
            </Title>
            <List>
                <List.Item>Sellers are responsible for ensuring that all items listed on the platform are accurate, clean, and in good condition.</List.Item>
                <List.Item>All products are subject to approval by Thrift Store Nepal before being published on the site.</List.Item>
                <List.Item>Misleading descriptions, counterfeit items, or any items violating Nepalese law are strictly prohibited.</List.Item>
                <List.Item>Once approved, your product listing will be visible on the website for potential buyers.</List.Item>
            </List>
        </Box>

        <Box mb="xl">
            <Title order={2} mb="md">
                5. Buying and Communication
            </Title>
            <List>
                <List.Item>Buyers can contact sellers directly through the chat feature provided on the website.</List.Item>
                <List.Item>Thrift Store Nepal does not guarantee the quality, condition, or authenticity of items purchased through the platform. Buyers are encouraged to communicate with sellers and inspect items carefully before completing a purchase.</List.Item>
                <List.Item>Any transactions or exchanges are the sole responsibility of the buyer and seller.</List.Item>
            </List>
        </Box>

        <Box mb="xl">
            <Title order={2} mb="md">
                6. Prohibited Items
            </Title>
            <Text>
                The following items are prohibited from being listed on Thrift Store Nepal:
            </Text>
            <List>
                <List.Item>Counterfeit or fake branded clothing.</List.Item>
                <List.Item>Stolen or illegal items.</List.Item>
                <List.Item>Items containing hazardous materials.</List.Item>
                <List.Item>Items violating Nepalese laws or cultural sensitivities.</List.Item>
            </List>
        </Box>

        <Box mb="xl">
            <Title order={2} mb="md">
                7. No Commission or Payment Handling
            </Title>
            <List>
                <List.Item>Thrift Store Nepal does not take any commission or facilitate payments. Transactions are carried out directly between buyers and sellers.</List.Item>
                <List.Item>We are not liable for any disputes regarding payments, non-delivery of goods, or any other issues arising between users.</List.Item>
            </List>
        </Box>

        <Box mb="xl">
            <Title order={2} mb="md">
                8. User Conduct
            </Title>
            <Text>
                By using our platform, you agree to:
            </Text>
            <List>
                <List.Item>Not engage in fraudulent activities.</List.Item>
                <List.Item>Respect the privacy and personal information of other users.</List.Item>
                <List.Item>Not use the platform for spam, harassment, or any unlawful activities.</List.Item>
            </List>
        </Box>

        <Box mb="xl">
            <Title order={2} mb="md">
                9. Limitation of Liability
            </Title>
            <List>
                <List.Item>Thrift Store Nepal acts as a facilitator and is not responsible for any disputes, damages, or losses arising from transactions made on the platform.</List.Item>
                <List.Item>We do not guarantee uninterrupted or error-free access to the website.</List.Item>
            </List>
        </Box>

        <Box mb="xl">
            <Title order={2} mb="md">
                10. Intellectual Property
            </Title>
            <List>
                <List.Item>All content on the website, including logos, designs, and text, is the property of Thrift Store Nepal. Unauthorized use is strictly prohibited.</List.Item>
                <List.Item>Sellers retain ownership of their product images but grant Thrift Store Nepal the right to use them for promotional purposes.</List.Item>
            </List>
        </Box>

        <Box mb="xl">
            <Title order={2} mb="md">
                11. Termination
            </Title>
            <List>
                <List.Item>We reserve the right to suspend or terminate your account at any time if you violate these terms and conditions or engage in unlawful activities.</List.Item>
            </List>
        </Box>

        <Box mb="xl">
            <Title order={2} mb="md">
                12. Changes to Terms and Conditions
            </Title>
            <List>
                <List.Item>Thrift Store Nepal reserves the right to update or modify these terms at any time without prior notice. Changes will be effective immediately upon posting on the website.</List.Item>
                <List.Item>Continued use of the platform after changes indicates your acceptance of the updated terms.</List.Item>
            </List>
        </Box>

        <Box mb="xl">
            <Title order={2} mb="md">
                13. Governing Law
            </Title>
            <List>
                <List.Item>These terms and conditions are governed by the laws of Nepal. Any disputes arising from these terms will be resolved exclusively in the courts of Nepal.</List.Item>
            </List>
        </Box>

        <Box mb="xl">
            <Title order={2} mb="md">
                14. Contact Us
            </Title>
            <Text mb="xs">
                If you have any questions or concerns about these terms and conditions, feel free to contact us at:
            </Text>
            <Text>
                Email: info@thriftstorenepal.com
            </Text>
        </Box>

        <Text italic mt="xl" mb="xl">
            Thank you for choosing Thrift Store Nepal! We look forward to helping you buy and sell sustainably.
        </Text>
        <Box mt="xl" />
    </Container>
}